export default {
	"contactUs":{
		"title":"Mở tài khoản FCA, bạn sẽ nhận được sự bảo vệ theo quy định có thẩm quyền nhất và bảo vệ tài chính an toàn nhất, lập tức mở tài khoản",
		"title1":"Mỗi một nhà giao dịch nghiêm túc đều xứng đáng được coi trọng.",
		"code":"Mã xác nhận",
	},
	"dividend": {
		"title": "Cổ tức CFD",
		"title1": "Tham chiếu cổ tức CFD:",
		"desc": "Xin lưu ý'việc tổng hợp cổ tức CFD sẽ được phản ánh trong số dư trên tài khoản MT4 của bạn dưới dạng tiền gửi hoặc rút tiền, được chú thích là \"Cổ tức\".",
		"btn": "Đăng ký ngay"
	},
	"notice":"近期我們發現EBC Group與一家提供線上加密貨幣產品名為“EBankc”的公司關聯起來了。<br/><br/>在此我們明確聲明，EBC Group的官方網站為 www.ebc.com  和 www.ebcfin. com ，頁面詳細介紹了我們所提供的產品資訊，並不包含加密貨幣。<br/><br/>同時，EBC Financial Group (UK) Ltd有且僅有一個官方網址 www.ebcfin.co.uk，並對所提供的產品進行了全面的介紹。 加密貨幣不是其中之一。<br/><br/>所有EBC集團公司均根據其經營所在司法管轄區的規則和法規運營，並將採取一切必要措施封锁任何協力廠商在未經授權的項目中使用其品牌。",
	"contact": {
		"title": "Bắt đầu khoản đầu tư của bạn từ đây",
		"pageTitle": "开户咨询",
		"pageEnTitle": "Inquiry",
		"name": "Họ/Biệt danh",
		"sexList": [{
			"label": "Ông",
			"value": "sir"
		}, {
			"label": "Cô",
			"value": "lady"
		}],
		"email": "Email",
		"btn": "Liên hệ chúng tôi",
		"tips1": "Xin hãy nhập tên của bạn!",
		"tips2": "Vui lòng nhập email của bạn!",
		"tips3": "Tin nhắn thành công!",
		"tips4": "Vui lòng nhập mã xác nhận!"
	},
	"column1": {
		"placeholder": "全站搜索",
		"login": "Đăng nhập",
		"langText": "Khu vực / ngôn ngữ của trang web EBC",
		"langList": [{
			"text": "繁体",
			"value": "zh_TW"
		}, {
			"text": "English",
			"value": "en_US"
		}, {
			"text": "한국어",
			"value": "ko_KR"
		}, {
			"text": "日本語",
			"value": "ja_JP"
		}, {
			"text": "ئۇيغۇر تىلى",
			"value": "weiwuer"
		},{
			"text": "Tiếng việt",
			"value": "vn"
		}]
	},
	"linkList": [{
		"title": "Tài khoản & Điều kiện",
		"list": [{
				"label": "Tài khoản giao dịch",
				"link": "/TradingAccount"
			},{
				"label": "Sản phẩm giao dịch",
				"link": "/tradingproduct"
			},{
				"label": "Quỹ đảm bảo/ đòn bẩy",
				"link": "/leverage-margin"
			},
			{
				"label": "Nạp/Rút tiền",
				"link": "/funding"
			},
			{
				"label": "Cổ tức",
				"link": "/dividend"
			}
		]
	},{
		"title": "Công cụ giao dịch",
		"list": [{
				"label": "Tải xuống MT4",
				"link": "/MT4"
			},{
				"label": "Tải xuống MT5",
				"link": "/MT5"
			},{
				"label": "Công cụ giao dịch MT4",
				"link": "/tools"
			}, {
				"label": "PAMM",
				"link": "/PAMM"
			}, {
				"label": "Phân tích thị trường",
				"link": "/market-analysis"
			}
		]
	},{
		"title": "Viện nghiên cứu EBC",
		"list": [{
				"label": "Trung tâm học tập",
				"link": "/LearningCenter"
			}
		]
	}, {
		"title": "Hoạt động gần đây",
		"list": [{
			"label": "Cuộc thi giao dịch",
			"link": "/win"
		},
		// {
		// 	"label": "Thách thức môi trường giao dịch mạnh nhất",
		// 	"link": "/no1"
		// }
	]
	}, {
		"title": "Mẫu hợp tác",
		"list": [{
			"label": "Quan hệ đối tác",
			"link": "/affiliate-programmes"
		},{
			"label": "Cơ chế phục vụ",
			"link": "/service"
		},{
			"label": "Công nghệ nền tảng",
			"link": "/technology"
		}]
	}, {
		"title": "Về EBC",
		"list": [{
			"label": "WHY EBC",
			"link": "/about-us"
		},  {
			"label": "Tài liệu hợp pháp",
			"link": "/LegalDocumen"
		}, {
			"label": "Trách nhiệm xã hội",
			"link": "/ESG"
		}, {
			"label": "FAQ",
			"link": "/FAQ"
		},{
			"label": "Xác minh kênh chính thức",
			"link": "/official-verification"
		}]
	}],
	"headlist": [{
		"text": "Trang chủ",
		"url": "/"
	}, {
		"text": "交易",
		"menu": [{
			"text": "交易产品",
			"url": "/tradingproduct"
		}, {
			"text": "交易账户",
			"url": "/TradingAccount"
		}, {
			"text": "交易条件",
			"menu": [{
				"text": "出入金",
				"url": "/funding"
			}, {
				"text": "杠杆与保证金",
				"url": "/leverage-margin"
			}]
		}, {
			"text": "交易平台",
			"menu": [{
				"text": "MT4",
				"url": "/MT4"
			}, {
				"text": "MAM",
				"url": "/MAM"
			}, {
				"text": "PAMM",
				"url": "/PAMM"
			}]
		}, {
			"text": "股息",
			"url": "/dividend"
		}]
	}, {
		"text": "LAB与工具",
		"menu": [{
			"text": "学习中心",
			"url": "/LearningCenter"
		}, {
			"text": "数据中心",
			"url": "/lab"
		}, {
			"text": "交易工具",
			"url": "/tools"
		}]
	}, {
		"text": "机构合作",
		"menu": [{
			"text": "金融科技",
			"url": "/technology"
		}, {
			"text": "机构服务",
			"url": "/service"
		}, {
			"text": "合作伙伴",
			"url": "/partner"
		}]
	}, {
		"text": "最新活动",
		"menu": [{
			"text": "领取订单流工具",
			"url": "/orderflow"
		}, {
			"text": "限时优享免息",
			"url": "/FreeSwap"
		}, {
			"text": "交易领薪计划",
			"url": "/pay"
		}]
	}, {
		"text": "关于EBC",
		"menu": [{
			"text": "Why EBC",
			"url": "/about-us"
		}, {
			"text": "FAQ",
			"url": "/FAQ"
		}]
	}, {
		"text": "交易大赛",
		"url": "/win"
	}, {
		"text": "跟单社区",
		"url": "/from0tohero"
	}, {
		"text": "免费开户",
		"url": "https://client.ebc-pro.com/signup?bid=5s71xp"
	}],
	"login": "Đăng nhập",
	"zhuce": "Đăng ký",
	"gendan": "Sao chép giao dịch",
	"pdfLang": "en",
	"bannerLang":"vn",
	"language":"Tiếng việt",
	"className": "en-box",
	"text": "EBC Financial Group bao gồm các công ty sau:<br>EBC Financial Group (SVG) LLC được cấp phép và quản lý bởi Cơ quan Dịch vụ Tài chính của Saint Vincent và Grenadines với số đăng ký 353 LLC 2020.<br>Các đơn vị liên quan khác<br>EBC Financial Group (UK) Limited được cấp phép và quản lý bởi Cơ quan quản lý tài chính Vương quốc Anh, với số quy định 927552.Trang web: <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcfin.co.uk\" rel=\"nofollow\">www.ebcfin.co.uk</a><br>EBC Financial Group (Australia) Pty Ltd (ACN: 619 073 237) được cấp phép và quản lý bởi Ủy ban Chứng khoán và Đầu tư (ASIC) (Số giấy phép: 500991). EBC Financial Group (Australia) Pty Ltd là một thực thể liên quan của EBC Financial Group (SVG) LLC. Hai thực thể này được quản lý riêng biệt. Các sản phẩm và dịch vụ tài chính được cung cấp trên trang web này KHÔNG được cung cấp bởi công ty Úc và không có quyền truy đòi đối với công ty Úc.<br>EBC Financial Group (Cayman) Limited được cấp phép và quản lý bởi Cơ quan tiền tệ Quần đảo Cayman (Số: 2038223). Trang mạng: <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcgroup.ky\" rel=\"nofollow\">www.ebcgroup.ky</a><br>Địa chỉ công ty: The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom, EC3V 4AB.Email: cs@ebc.comĐiện thoại: (+44) 20 3376 9662<br>Tuyên bố miễn trừ trách nhiệm: EBC Financial Group hoàn toàn không tham gia vào bất kỳ hoạt động tiền điện tử hoặc cung cấp Hợp đồng chênh lệch tiền điện tử (CFD) nào. Dịch vụ tài chính của chúng tôi chỉ liên quan đến các công cụ truyền thống. Khách hàng vui lòng chú ý rằng mọi bản tham chiếu các dịch vụ liên quan đến tiền điện tử sử dụng tên EBC đều trái phép và không chính xác. Mọi kết quả trong quá khứ không biểu thị kết quả trong tương lai và nội dung trên trang web chỉ mang tính tham khảo và không cấu thành bất kỳ lời khuyên đầu tư nào.<br>Giới hạn khu vực: EBC không cung cấp dịch vụ cho cư dân của các khu vực sau: Afghanistan, Belarus, Myanmar, Canada, Cộng hòa Trung Phi, Congo, Cuba, Cộng hòa Dân chủ Congo, Eritrea, Haiti, Iran, Iraq, Lebanon, Libya, Malaysia, Mali, Bắc Triều Tiên (Cộng hòa Dân chủ Nhân dân Triều Tiên), Nga, Somalia, Sudan, Nam Sudan, Syria, Ukraine (bao gồm các khu vực Crimea, Donetsk và Luhansk), Hoa Kỳ, Venezuela và Yemen. Để biết thêm thông tin, vui lòng xem tại phần Câu hỏi thường gặp của chúng tôi.<br>Tiết lộ về tuân thủ: Trang web của Công ty có thể xem được trên toàn cầu và không hướng tới bất kỳ tổ chức nào. Quyền và nghĩa vụ của bạn được xác định bởi các cơ quan quản lý và tổ chức trong khu vực bạn chọn. Luật pháp và quy định của địa phương có thể cấm hoặc hạn chế bạn truy cập, tải xuống, phân phối, chia sẻ hoặc sử dụng bất kỳ tài liệu và thông tin nào được đăng trên trang web.<br>Tiết lộ sản phẩm giao dịch có rủi ro cao: CFD là sản phẩm tài chính phức tạp và việc sử dụng đòn bẩy có nguy cơ thua lỗ cao. Giao dịch ký quỹ có mức độ rủi ro cao và có thể không phù hợp với tất cả các nhà đầu tư. Bạn nên cân nhắc những thông tin trên với mục tiêu, tình hình tài chính và khả năng chịu rủi ro của riêng bạn. Bạn có thể mất một phần hoặc toàn bộ số tiền gốc của mình. Chúng tôi khuyên bạn nên tìm kiếm lời khuyên độc lập để đảm bảo bạn hiểu đầy đủ các rủi ro trước khi đưa ra quyết định đầu tư. Vui lòng đọc kỹ tuyên bố tiết lộ rủi ro liên quan trước khi giao dịch.",
	"waptext": "EBC Financial Group bao gồm các công ty sau:<br>EBC Financial Group (SVG) LLC được cấp phép và quản lý bởi Cơ quan Dịch vụ Tài chính của Saint Vincent và Grenadines với số đăng ký 353 LLC 2020.<br>Các đơn vị liên quan khác<br>EBC Financial Group (UK) Limited được cấp phép và quản lý bởi Cơ quan quản lý tài chính Vương quốc Anh, với số quy định 927552.Trang web: <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcfin.co.uk\" rel=\"nofollow\">www.ebcfin.co.uk</a><br>EBC Financial Group (Australia) Pty Ltd (ACN: 619 073 237) được cấp phép và quản lý bởi Ủy ban Chứng khoán và Đầu tư (ASIC) (Số giấy phép: 500991). EBC Financial Group (Australia) Pty Ltd là một thực thể liên quan của EBC Financial Group (SVG) LLC. Hai thực thể này được quản lý riêng biệt. Các sản phẩm và dịch vụ tài chính được cung cấp trên trang web này KHÔNG được cung cấp bởi công ty Úc và không có quyền truy đòi đối với công ty Úc.<br>EBC Financial Group (Cayman) Limited được cấp phép và quản lý bởi Cơ quan tiền tệ Quần đảo Cayman (Số: 2038223). Trang mạng: <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcgroup.ky\" rel=\"nofollow\">www.ebcgroup.ky</a><br>Địa chỉ công ty: The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom, EC3V 4AB.Email: cs@ebc.comĐiện thoại: (+44) 20 3376 9662<br>Tuyên bố miễn trừ trách nhiệm: EBC Financial Group hoàn toàn không tham gia vào bất kỳ hoạt động tiền điện tử hoặc cung cấp Hợp đồng chênh lệch tiền điện tử (CFD) nào. Dịch vụ tài chính của chúng tôi chỉ liên quan đến các công cụ truyền thống. Khách hàng vui lòng chú ý rằng mọi bản tham chiếu các dịch vụ liên quan đến tiền điện tử sử dụng tên EBC đều trái phép và không chính xác. Mọi kết quả trong quá khứ không biểu thị kết quả trong tương lai và nội dung trên trang web chỉ mang tính tham khảo và không cấu thành bất kỳ lời khuyên đầu tư nào.<br>Giới hạn khu vực: EBC không cung cấp dịch vụ cho cư dân của các khu vực sau: Afghanistan, Belarus, Myanmar, Canada, Cộng hòa Trung Phi, Congo, Cuba, Cộng hòa Dân chủ Congo, Eritrea, Haiti, Iran, Iraq, Lebanon, Libya, Malaysia, Mali, Bắc Triều Tiên (Cộng hòa Dân chủ Nhân dân Triều Tiên), Nga, Somalia, Sudan, Nam Sudan, Syria, Ukraine (bao gồm các khu vực Crimea, Donetsk và Luhansk), Hoa Kỳ, Venezuela và Yemen. Để biết thêm thông tin, vui lòng xem tại phần Câu hỏi thường gặp của chúng tôi.<br>Tiết lộ về tuân thủ: Trang web của Công ty có thể xem được trên toàn cầu và không hướng tới bất kỳ tổ chức nào. Quyền và nghĩa vụ của bạn được xác định bởi các cơ quan quản lý và tổ chức trong khu vực bạn chọn. Luật pháp và quy định của địa phương có thể cấm hoặc hạn chế bạn truy cập, tải xuống, phân phối, chia sẻ hoặc sử dụng bất kỳ tài liệu và thông tin nào được đăng trên trang web.<br>Tiết lộ sản phẩm giao dịch có rủi ro cao: CFD là sản phẩm tài chính phức tạp và việc sử dụng đòn bẩy có nguy cơ thua lỗ cao. Giao dịch ký quỹ có mức độ rủi ro cao và có thể không phù hợp với tất cả các nhà đầu tư. Bạn nên cân nhắc những thông tin trên với mục tiêu, tình hình tài chính và khả năng chịu rủi ro của riêng bạn. Bạn có thể mất một phần hoặc toàn bộ số tiền gốc của mình. Chúng tôi khuyên bạn nên tìm kiếm lời khuyên độc lập để đảm bảo bạn hiểu đầy đủ các rủi ro trước khi đưa ra quyết định đầu tư. Vui lòng đọc kỹ tuyên bố tiết lộ rủi ro liên quan trước khi giao dịch.",
}